import { useState } from 'react';
import { hasAnyPolicy } from './policyMeta';
import PoliciesDrawer from './PoliciesDrawer';

/**
 * Implicit-consent microcopy for the Book CTA: "By booking, you agree
 * to {name}'s booking policies" with a link that opens the full-text
 * drawer. Callers gate rendering on the contact-confirmation step;
 * this component additionally returns null when no policies are set.
 */
const PoliciesAgreementNote = ({ bookingPage, className = '' }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (!hasAnyPolicy(bookingPage)) {
    return null;
  }

  const name =
    bookingPage?.businessName?.trim() || bookingPage?.providerName?.trim() || null;

  return (
    <>
      <p className={`text-xs text-center text-themed-secondary mt-2 ${className}`}>
        By booking, you agree to {name ? `${name}'s` : 'the'}{' '}
        <button
          type="button"
          onClick={() => setDrawerOpen(true)}
          aria-haspopup="dialog"
          // p-2/-m-2 pads the tap target to ~44px without shifting the visual
          className="underline text-themed-primary hover:opacity-80 p-2 -m-2"
        >
          booking policies
        </button>
        .
      </p>
      <PoliciesDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        bookingPage={bookingPage}
      />
    </>
  );
};

export default PoliciesAgreementNote;
